// extracted by mini-css-extract-plugin
export var completionBody = "_me-2";
export var completionCard = "_me-0";
export var completionFooter = "_me-3";
export var completionTitle = "_me-1";